import {Component, OnInit} from '@angular/core';
import {MdDialogRef} from '@angular/material';
import {Router} from "@angular/router";

@Component({
  selector: 'confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})

export class ConfirmationDialogComponent implements OnInit {

  public model: any = {
    authorizedUser: null,
    newUnit: null,
  };

  constructor(public thisDialogRef: MdDialogRef<ConfirmationDialogComponent>, private router: Router) {
  }

  ngOnInit() {
  }

  onCloseConfirm() {
    this.thisDialogRef.close('Confirm');
    this.router.navigate(['participationForm']);
  }

  onCloseCancel() {
    this.thisDialogRef.close('Cancel');
  }

  getMessage() {
    if (this.model.authorizedUser === null || this.model.newUnit === null) {
      return ``;
    }

    if (!this.model.authorizedUser || !this.model.newUnit) {
      return `<p class="text-warning"><i class="glyphicon glyphicon-alert"></i> If you need to enroll yourself in the program, please contact your unit representative.</p>`;
    }

    return `<p class="text-success">Select Continue to enroll new unit.</p>`;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/confirmation-dialog/confirmation-dialog.component.ts